import { httpRequest } from '@/apis/request'

enum Apis {
  wechatGetUrl = 'wechat_qrcode', //'wechat/scan/get_url',
  wechatScanStatus = 'wechat_qrcode/status', //'wechat/scan/status',
  surplusQRcodeIdUrl = 'get_surplus_qrcode_id',
  refreshQRcodeIdUrl = 'refresh_surplus_qrcode',
}

/**
 * @description 获取微信扫码信息
 * @link https://api.thinkerx.com/web/#/159/15452
 */
export function wechatGetUrl(payload: { code_type: string }) {
  return httpRequest.get(Apis.wechatGetUrl, payload)
}

/**
 * @description 检查扫码状态
 * @link https://api.thinkerx.com/web/#/159/15453
 */
export function wechatScanStatus(payload: { nonce_str: string }) {
  return httpRequest.get(Apis.wechatScanStatus, payload)
}

/**
 * @description 获取用户余料入库码id接口
 * @link http://api.thinkerx.com:8060/web/#/162/16845
 */
export function getSurplusQRcodeIdFn(payload: { uid: number }) {
  return httpRequest.get(Apis.surplusQRcodeIdUrl, payload)
}
/**
 * @description 获取用户余料入库码id接口
 * @link http://api.thinkerx.com:8060/web/#/162/16845
 */
export function postRefreshQRcodeIdFn(payload: { uid: number }) {
  return httpRequest.post(Apis.refreshQRcodeIdUrl, payload)
}
